import { lazy } from 'react';

// project-imports
import Loadable from 'components/Loadable';
import ModuleRoute from 'components/routes/ModuleRoute';
import DashboardLayout from 'layout/Dashboard';
import CMSManagement from 'pages/cms/CMSManagement';

// render - dashboard
const DashboardHome = Loadable(lazy(() => import('pages/dashboard')));
const Settings = Loadable(lazy(() => import('pages/settings')));
const NotFound = Loadable(lazy(() => import('pages/errors/NotFound')));
const AuditLogs = Loadable(lazy(() => import('pages/audit-logs')));
const Profile = Loadable(lazy(() => import('pages/profile')));
const Users = Loadable(lazy(() => import('pages/users')));
const Reports = Loadable(lazy(() => import('pages/reports')));
const Notifications = Loadable(lazy(() => import('pages/notifications')));
const AppSettings = Loadable(lazy(() => import('pages/app-settings')));
const SubscriptionLogs = Loadable(lazy(() => import('pages/subscription-logs')));
const SubscriptionPlansModule = Loadable(lazy(() => import('pages/subscription-plans/SubscriptionPlansModule')));
const SubscriptionPlansListPage = Loadable(lazy(() => import('pages/subscription-plans/SubscriptionPlansListPage')));
const SubscriptionPlanFormPage = Loadable(lazy(() => import('pages/subscription-plans/SubscriptionPlanFormPage')));
const TvServices = Loadable(lazy(() => import('pages/providers-and-channels')));
const StreamingServices = Loadable(lazy(() => import('pages/streaming-services')));
const SportsPackages = Loadable(lazy(() => import('pages/sports-packages')));
const Leagues = Loadable(lazy(() => import('pages/leagues')));
const HomeProgramsModule = Loadable(lazy(() => import('pages/home-programs/HomeProgramsModule')));
const HomeProgramsListPage = Loadable(lazy(() => import('pages/home-programs/HomeProgramsListPage')));
const HomeProgramFormPage = Loadable(lazy(() => import('pages/home-programs/HomeProgramFormPage')));
const PdfChannelSelection = Loadable(lazy(() => import('pages/channel-selection')));

const StaffList = Loadable(lazy(() => import('pages/users/staffList')));
const RoleManagement = Loadable(lazy(() => import('pages/users/roleManagement')));
// ==============================|| MAIN ROUTES ||============================== //

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [
    { path: 'dashboard', element: <DashboardHome /> },
    { path: 'users', element: <ModuleRoute module="users"><Users /></ModuleRoute> },
    { path: 'staff', element: <ModuleRoute module="staff"><StaffList /></ModuleRoute> },
    { path: 'role', element: <ModuleRoute module="roles"><RoleManagement /></ModuleRoute> },
    { path: 'settings', element: <Settings /> },
    { path: 'profile', element: <Profile /> },
    { path: 'audit-logs', element: <ModuleRoute module="audit"><AuditLogs /></ModuleRoute> },
    { path: 'cms', element: <ModuleRoute module="cms"><CMSManagement /></ModuleRoute> },
    { path: 'notifications', element: <ModuleRoute module="notification"><Notifications /></ModuleRoute> },
    { path: 'app-settings', element: <ModuleRoute module="settings"><AppSettings /></ModuleRoute> },
    { path: 'reports', element: <ModuleRoute module="report"><Reports /></ModuleRoute> },
    { path: 'subscription-logs', element: <ModuleRoute module="subscription"><SubscriptionLogs /></ModuleRoute> },
    {
      path: 'subscription-plans',
      element: <SubscriptionPlansModule />,
      children: [
        { index: true, element: <SubscriptionPlansListPage /> },
        { path: 'new', element: <SubscriptionPlanFormPage /> },
        { path: ':planId', element: <SubscriptionPlanFormPage /> },
      ],
    },
    { path: 'providersandchannels', element: <ModuleRoute module="providers"><TvServices /></ModuleRoute> },
    { path: 'pdf-channel-selection', element: <ModuleRoute module="providers"><PdfChannelSelection /></ModuleRoute> },
    { path: 'streaming-services', element: <ModuleRoute module="streaming_services"><StreamingServices /></ModuleRoute> },
    { path: 'sports-packages', element: <ModuleRoute module="sports_packages"><SportsPackages /></ModuleRoute> },
    { path: 'leagues', element: <ModuleRoute module="leagues"><Leagues /></ModuleRoute> },
    {
      path: 'home-programs',
      element: <HomeProgramsModule />,
      children: [
        { index: true, element: <HomeProgramsListPage /> },
        { path: 'new', element: <HomeProgramFormPage /> },
        { path: ':programId', element: <HomeProgramFormPage /> },
      ],
    },
    { path: '*', element: <NotFound /> }
  ]
};

export default MainRoutes;
